export default __webpack_public_path__ + "static/media/x.68d68c6d.svg";